import { render, staticRenderFns } from "./RegisterInvitation.vue?vue&type=template&id=07190ea6&scoped=true&"
import script from "./RegisterInvitation.vue?vue&type=script&lang=js&"
export * from "./RegisterInvitation.vue?vue&type=script&lang=js&"
import style0 from "./RegisterInvitation.vue?vue&type=style&index=0&id=07190ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07190ea6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VForm,VSpacer})
